// Vendor imports
const classNames = require('classnames')
const _ = require('lodash')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const AddToCollectionModal = require('client-v2/common/containers/lightweight-engagement/containers/add-to-collection-modal/components/modal-smart')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('ContentAddModalUrlSubmitted')

function ContentAddModalUrlSubmitted({
  isAddedToProfile,
  className,
  style,
  onUnmixPromptConfirm
}) {
  return (
    tag('div', {
      className: classNames(
        className,
        bem.block()
      ),
      style
    },
      isAddedToProfile && (
        tag('div', {
          className: bem.element('header-toast')
        },
          'Added to your profile!'
        )
      ),
      tag(AddToCollectionModal, {
        // Override mapDispatchToProps
        onDismiss: _.noop,
        onUnmixPromptConfirm
      })
    )
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  ContentAddModalUrlSubmitted.propTypes = {
    // Flags
    isAddedToProfile: PropTypes.bool,
    // Values
    className: PropTypes.string,
    style: PropTypes.object,
    // Callbacks
    onUnmixPromptConfirm: PropTypes.func.isRequired
  }
}

module.exports = ContentAddModalUrlSubmitted
